(function() {
    
    'use strict';
    
    angular
    .module('GorillaBoy.services')
    .service('PromiseWatcherService', [
        '$timeout', 'ClientMetricsService',
        PromiseWatcherService
    ]);

    function PromiseWatcherService($timeout, ClientMetricsService) {
        var self = this,
            promiseWatchers = {},
            timeoutPromise = [];

        // We support having multiple promiseWatchers by creating an instance for every metric event that we wish to record.
        var PromiseWatcherInstance = function() {
            this.timer = {
                start: null,
                stop: null,
                getDuration: function() {
                    return (this.stop - this.start);
                }
            };
            this.promisesResolvedCallback = null;
            this.promises = [];
        };

        PromiseWatcherInstance.prototype.startTimer = function() {
            this.timer.start = new Date().getTime(); 
        };
        
        PromiseWatcherInstance.prototype.stopTimer = function() {
            this.timer.stop = new Date().getTime();
        };
        
        PromiseWatcherInstance.prototype.clearTimer = function() {
            this.timer.start = null;
            this.timer.stop = null;
        };

        PromiseWatcherInstance.prototype.remove = function(myPromise) {
            var numPromises = this.promises.length,
                removeIndex;

            for(var i=0; i<numPromises; i++) {
                if (myPromise === this.promises[i]) {
                    removeIndex = i;
                    break;
                }
            }

            if (removeIndex !== null) {
                this.promises.splice(removeIndex, 1);  
            }
        };

        /* Init - Activates an instance of a promise watcher
         * @param {string} metricEvent for which this instance is recording.
         * (optional) @param {function} callback to be called once all promises have resolved
         *   - promisesResolvedCallback(timer) <- passed the timer obj
         *   - If omitted, a default function calling ClientMetricsService.recordLatencyEvent() will be added.
         */
        self.init = function(metricEvent, callback) {
            var newPromiseWatcher = new PromiseWatcherInstance();

            if (callback) {
                newPromiseWatcher.promisesResolvedCallback = callback;
            } else {
                newPromiseWatcher.promisesResolvedCallback = function(timer) {
                    ClientMetricsService.recordLatencyEvent(metricEvent, timer.getDuration());
                };
            }
            
            promiseWatchers[metricEvent.name] = newPromiseWatcher;
        };

        /* Add - Adds a promise to the promise watcher associated with metricEvent
         * Calls the watcher's saved callback function in a finally function when the last promise for a given metricEvent is returned.
         * @param {promise} promise
         * @param {metricEvent} metricEvent
         */
        self.add = function(promise, metricEvent) {
            var promiseWatcher = promiseWatchers[metricEvent.name];

            if (promise && promiseWatcher) {
                if (promiseWatcher.promises.length === 0) {
                    promiseWatcher.clearTimer();
                    promiseWatcher.startTimer();
                }

                promiseWatcher.promises.push(promise);

                promise.finally(function() {
                    promiseWatcher.remove(promise);

                    if (promiseWatcher.promises.length === 0) {
                        // All promises for this metric event have completed.
                        promiseWatcher.stopTimer();
                        promiseWatcher.promisesResolvedCallback(promiseWatcher.timer);
                        delete promiseWatchers[metricEvent.name];
                    }
                });
            }
        };
        
        // Generic timeout watcher to wait for completion of an unknown amount of events.
        self.addTimeoutWatcher = function(callback, duration) {
            
            // Cancel the old one
            if (timeoutPromise) {
                $timeout.cancel(timeoutPromise);
            }
            
            // Set the new one
            timeoutPromise = $timeout(function() {
                callback();
            }, duration);

        };
        

    } // Service Function
    
})(); // IEFE